import { createClient } from '@supabase/supabase-js'

import { useWaiterStore } from '../stores/use-waiter-store'
import type { Database } from '../types/supabase'
import { posthog } from './posthog'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseKey = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY

if (!supabaseUrl || !supabaseKey) {
  throw new Error(
    'Missing Supabase environment variables. Please check your .env file.',
  )
}

export const supabase = createClient<Database>(supabaseUrl, supabaseKey)

export const supabaseWaiter = createClient<Database>(supabaseUrl, supabaseKey, {
  accessToken: async () => {
    return localStorage.getItem('@usecomanda:waiter_token') ?? ''
  },
  global: {
    fetch: async (url, options) => {
      const response = await fetch(url, options)

      if (response.status === 401 || response.status === 403) {
        console.warn(
          'Operational session is no longer authorized. Clearing session...',
        )

        localStorage.removeItem('@usecomanda:waiter_token')

        posthog.reset()
        useWaiterStore.getState().clearWaiter()

        localStorage.removeItem('@usecomanda:waiter_data')

        window.location.replace('/garcom')
      }

      return response
    },
  },
})
